.headerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.workflowContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 150px;
}

.stationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.station {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 20px;
    height: 100%;
    width: 100%;
    background-color: var(--hps-blue);
    border: 3px solid;
    border-radius: 8px;
}

.stationContainerBookend {
    flex: 1;
    height: 120px;
}

.stationContainerMiddle {
    width: 50%;
}

.station:focus {
    outline: 2px solid var(--hps-light-blue);
    outline-offset: 2px;
}

.stationCompleted {
    border-color: var(--hps-dark-green);
}

.stationInProgress {
    border-color: var(--hps-light-blue);
}

.stationPending {
    border-color: var(--hps-gray);
}

.stationOverdue {
    border-color: var(--hps-red);
}

.stationContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.statusBadge {
    padding: 4px 8px;
    border-radius: 4px;
}

.statusCompleted {
    background-color: var(--hps-dark-green);
}

.statusInProgress {
    background-color: var(--hps-light-blue);
}

.statusPending {
    background-color: var(--hps-gray);
}

.statusOverdue {
    background-color: var(--hps-red);
}

.arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    color: var(--hps-gray);
    font-size: 24px;
}

.middleGroup {
    display: flex;
    align-items: center;
    border: 2px dashed var(--hps-white);
    border-radius: 8px;
    padding: 16px;
    flex: 2;
    height: 120px;
}

.handsFreeModeContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 4px;
}

.underStationsContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.underStationsIconSpacer {
    /* Must match the width of a single arrow icon + its padding. */
    width: 37px; 
}

.underBookendStationLinkContainer {
    flex: 1;
    display: flex;
    justify-content: center;
}

.underMiddleGroupContainer {
    flex: 2;
    padding: 0px 16px;
    display: flex;
    justify-content: center;
}
